// Auto generated file, do not manually modify!
// com.hotpads.screening.client.credit.enums.CreditReportStatus

export enum CreditReportStatus {
  AVAILABLE = 'AVAILABLE',
  CONSUMER_IS_MINOR = 'CONSUMER_IS_MINOR',
  DECEASED = 'DECEASED',
  EXPIRED = 'EXPIRED',
  FILE_BLOCKED = 'FILE_BLOCKED',
  FILE_FROZEN = 'FILE_FROZEN',
  FILE_LOCKED = 'FILE_LOCKED',
  LACK_OF_INFORMATION = 'LACK_OF_INFORMATION',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NO_RECORD_FOUND = 'NO_RECORD_FOUND',
  NO_SSN = 'NO_SSN',
  REAUTHENTICATING = 'REAUTHENTICATING',
  SERVICE_FAILED = 'SERVICE_FAILED',
  TOO_MANY_RECORDS = 'TOO_MANY_RECORDS',
}

export const CreditReportStatus_values = [
  CreditReportStatus.AVAILABLE,
  CreditReportStatus.CONSUMER_IS_MINOR,
  CreditReportStatus.DECEASED,
  CreditReportStatus.EXPIRED,
  CreditReportStatus.FILE_BLOCKED,
  CreditReportStatus.FILE_FROZEN,
  CreditReportStatus.FILE_LOCKED,
  CreditReportStatus.LACK_OF_INFORMATION,
  CreditReportStatus.NOT_AVAILABLE,
  CreditReportStatus.NO_RECORD_FOUND,
  CreditReportStatus.NO_SSN,
  CreditReportStatus.REAUTHENTICATING,
  CreditReportStatus.SERVICE_FAILED,
  CreditReportStatus.TOO_MANY_RECORDS,
] as const;
